import {
  Component,
  input,
  output,
  computed,
  signal,
  effect,
} from '@angular/core';

export interface Tab {
  id: string;
  label: string;
  iconClass?: string;
}

@Component({
  selector: 'maximizer-outlook-tab-switcher',
  standalone: true,
  template: `
    <div class="tab-switcher flex caption" role="tablist">
      @for (tab of tabs(); track tab.id) {
        <button
          role="tab"
          class="tab-button"
          [class.active]="tab.id === active()"
          [attr.aria-selected]="tab.id === active()"
          (click)="selectTab(tab.id)"
        >
          @if (tab.iconClass) {
            <span class="inline-flex" [class]="tab.iconClass"></span>
          }
          <span class="text-body">{{ tab.label }}</span>
        </button>
      }
    </div>
  `,
  styles: [
    `
      .tab-button {
        @apply flex-1 justify-center flex items-center gap-1.5 px-3 py-2.5
         text-neutral-90 border-b-2 border-b-transparent cursor-pointer bg-neutral-5 hover:bg-neutral-10;
      }

      .tab-button.active {
        @apply text-black border-bush-green-100;
      }
    `,
  ],
})
export class OutlookTabSwitcherComponent {
  tabs = input<Tab[]>([]);
  activeInput = input<string | undefined>();

  tabChange = output<string>();

  private readonly activeTab = signal<string>('');

  active = computed(() => this.activeInput() ?? this.activeTab());

  constructor() {
    effect(() => {
      const tabs = this.tabs();
      const activeInput = this.activeInput();

      if (!activeInput && tabs.length && !this.activeTab()) {
        this.activeTab.set(tabs[0].id);
      }
    });
  }

  selectTab(value: string) {
    if (this.activeInput()) {
      this.tabChange.emit(value);
    } else {
      this.activeTab.set(value);
      this.tabChange.emit(value);
    }
  }
}
